<div class="main-page">
  <div class="container">
    <div class="page-content">
      <div class="row-content">
        <div
          class="user-profile profile-mobile"
          [hidden]="isShowBack && showTab"
        >
          <div class="account-settings">
            <div class="user-info flex">
              <img
                src="{{
                  isLoggedIn && userProfile?.avatar
                    ? userProfile.avatar
                    : 'assets/images/icons/user-logo.png'
                }}"
                alt="User Profile Image"
              />
              <p class="user-name" *ngIf="isLoggedIn">
                {{ userProfile?.full_name }}
              </p>
              <div class="guest-info" *ngIf="!isLoggedIn">
                <a
                  class="guest-action w-full"
                  [routerLink]="['/authenticate/login']"
                  >Log In</a
                >
                <p>sign in to experience best practices</p>
              </div>
            </div>
            <div class="edit-profile">
              <div class="main-setting medium-margin-bottom" *ngIf="isLoggedIn">
                <div
                  class="flex pointer"
                  (click)="
                    isDesktop
                      ? activeTab('edit')
                      : setCurrentRoute('/profile/edit')
                  "
                  [class.active-tab]="showTab == 'edit'"
                >
                  <div class="profile-info">
                    <div class="circle-icon">
                      <img
                        src="assets/images/icons/info.svg"
                        alt="Info Icon"
                        *ngIf="showTab != 'edit'"
                      />
                      <img
                        src="assets/images/icons/Info-blue.svg"
                        alt="Info Icon"
                        *ngIf="showTab == 'edit'"
                      />
                    </div>
                    <p>Profile Info</p>
                  </div>
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right.svg"
                    alt="Right Arrow"
                    *ngIf="showTab != 'edit'"
                  />
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right-blue.svg"
                    alt="Right Arrow"
                    *ngIf="showTab == 'edit'"
                  />
                </div>
                <ng-container *ngIf="isDesktop">
                  <hr class="custom-hr" />
                  <div
                    class="flex pointer"
                    (click)="
                      isDesktop
                        ? activeTab('orderHistory')
                        : setCurrentRoute('/order-history')
                    "
                    [class.active-tab]="showTab == 'orderHistory'"
                  >
                    <div class="profile-info">
                      <div class="circle-icon">
                        <img
                          src="assets/images/icons/notepad.svg"
                          alt="Icon"
                          *ngIf="showTab != 'orderHistory'"
                        />
                        <img
                          src="assets/images/icons/notepad-blue.svg"
                          alt="Info Icon"
                          *ngIf="showTab == 'orderHistory'"
                        />
                      </div>
                      <p>Order History</p>
                    </div>
                    <img
                      class="arrow"
                      src="assets/images/icons/arrow-right.svg"
                      alt="Right Arrow"
                      *ngIf="showTab != 'orderHistory'"
                    />
                    <img
                      class="arrow"
                      src="assets/images/icons/arrow-right-blue.svg"
                      alt="Right Arrow"
                      *ngIf="showTab == 'orderHistory'"
                    />
                  </div>
                </ng-container>
                <hr class="custom-hr" />
                <div
                  class="flex pointer"
                  (click)="
                    isDesktop ? activeTab('wallet') : setCurrentRoute('/wallet')
                  "
                  [class.active-tab]="showTab == 'wallet'"
                >
                  <div class="profile-info">
                    <div class="circle-icon">
                      <img
                        src="assets/images/icons/wallet-gray.svg"
                        alt="Wallet Icon"
                        *ngIf="showTab != 'wallet'"
                      />
                      <img
                        src="assets/images/icons/wallet-blue.svg"
                        alt="Info Icon"
                        *ngIf="showTab == 'wallet'"
                      />
                    </div>
                    <p>Wallet</p>
                  </div>
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right.svg"
                    alt="Right Arrow"
                    *ngIf="showTab != 'wallet'"
                  />
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right-blue.svg"
                    alt="Right Arrow"
                    *ngIf="showTab == 'wallet'"
                  />
                </div>
                <hr class="custom-hr" />
                <div
                  class="flex pointer"
                  (click)="
                    isDesktop
                      ? activeTab('wishList')
                      : setCurrentRoute('/wishlist')
                  "
                  [class.active-tab]="showTab == 'wishList'"
                >
                  <div class="profile-info">
                    <div class="circle-icon">
                      <img
                        src="assets/images/icons/wishlist.svg"
                        alt="Wishlist Icon"
                        *ngIf="showTab != 'wishList'"
                      />
                      <img
                        src="assets/images/icons/wishlist-blue.svg"
                        alt="Wishlist Icon"
                        *ngIf="showTab == 'wishList'"
                      />
                    </div>
                    <p>Wishlist</p>
                  </div>
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right.svg"
                    alt="Right Arrow"
                    *ngIf="showTab != 'wishList'"
                  />
                  <img
                    class="arrow"
                    src="assets/images/icons/arrow-right-blue.svg"
                    alt="Right Arrow"
                    *ngIf="showTab == 'wishList'"
                  />
                </div>
              </div>

              <!-- <div class="king-club-state">
                <span class="title"> Your KingClub Level: </span>
                <div class="club-level">
                  <img
                    src="{{ clubIcons.BronzeBadge2 }}"
                    alt="club level icon"
                  />
                  <div class="remaining-time">
                    <span class="time-title">Time Left:</span>
                    <div class="time-container">
                      <div class="remaining-days">
                        <span class="value">20</span>
                        <span class="title">Days</span>
                      </div>
                      <div class="divider">
                        <img
                          src="{{ clubIcons.TwoDots }}"
                          alt="two dots icon"
                        />
                      </div>
                      <div class="remaining-hours">
                        <span class="value">18</span>
                        <span class="title">Hours</span>
                      </div>
                      <div class="divider">
                        <img
                          src="{{ clubIcons.TwoDots }}"
                          alt="two dots icon"
                        />
                      </div>
                      <div class="remaining-minutes">
                        <span class="value">55</span>
                        <span class="title">Minutes</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="progress-container">
                  <div class="top-row">
                    <span>Points:</span>
                    <span>-</span>
                  </div> -->
              <!-- <meter id="fuel" min="0" max="100" low="33" high="66" optimum="80" value="50">
                    at 50/100
                  </meter> -->
              <!-- </div>
              </div> -->

              <div
                class="section-settings appearance-settings general-settings"
              >
                <h4 class="section-title">Appearance</h4>
                <div class="border-line">
                  <button
                    mat-button
                    class="preference-btn"
                    (click)="openPreference()"
                  >
                    <div class="profile-item">
                      <p class="item-title">Preferences</p>
                      <div class="flex">
                        <div class="store-region flex">
                          <img [src]="storeRegionInfo?.image" alt="" />
                          <span>{{ storeRegionInfo?.code }}</span>
                        </div>
                        <img
                          class="arrow"
                          src="assets/images/icons/arrow-right.svg"
                          alt="Right Arrow"
                        />
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <div class="section-settings general-settings">
                <h4 class="section-title">General</h4>
                <div class="border-line">
                  <div
                    *ngFor="
                      let staticLink of storeDetail?.static_pages;
                      last as isLast
                    "
                  >
                    <div
                      [routerLink]="['/pages', staticLink.slug]"
                      class="profile-item pointer"
                    >
                      <p class="item-title">{{ staticLink.title }}</p>
                      <img
                        class="arrow"
                        src="assets/images/icons/arrow-right.svg"
                        alt="Right Arrow"
                      />
                    </div>
                    <hr class="custom-hr" />
                  </div>
                  <div
                    class="profile-item logout-action flex pointer"
                    (click)="logOut()"
                    *ngIf="isLoggedIn && !isDesktop"
                  >
                    <p class="item-title">Logout</p>
                    <img
                      src="assets/images/icons/logout-red.svg"
                      alt="Logout"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-contents" *ngIf="isDesktop">
          <app-whish-list *ngIf="showTab == 'wishList'"></app-whish-list>
          <app-shop-summary *ngIf="showTab == 'shopSummary'"></app-shop-summary>
          <app-wallet
            *ngIf="showTab == 'wallet'"
            (isChargeWallet)="setWalletChargeTab($event)"
          ></app-wallet>
          <app-edit-profile *ngIf="showTab == 'edit'"></app-edit-profile>
          <div class="order-history" *ngIf="showTab == 'orderHistory'">
            <p class="order-history-title">Order History</p>
            <app-shop-summary></app-shop-summary>
          </div>
          <app-charge-wallet-sheet
            *ngIf="showTab == 'wallet-charge'"
          ></app-charge-wallet-sheet>
        </div>
        <div class="page-title" *ngIf="showTab">
          <p>
            <span *ngIf="showTab == 'wishList'">
              {{ 'profilePage.wishList' | translate }}
            </span>
            <span *ngIf="showTab == 'shopSummary'">
              {{ 'profilePage.shopSummary' | translate }}
            </span>
            <span *ngIf="showTab == 'wallet'">
              {{ 'profilePage.wallet' | translate }}
            </span>
            <span *ngIf="showTab == 'edit'">
              {{ 'profilePage.editProfile' | translate }}
            </span>
          </p>
        </div>
        <div *ngIf="showTab && isShowBack" class="back-button">
          <img src="assets/images/icons/back.svg" (click)="backButton()" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #selectThemeDialog>
  <div class="theme-dialog-container">
    <div class="w-full dialog-header">
      <h2>Theme</h2>
    </div>
    <hr class="custom-hr" />
    <div class="dialog-detail w-full flex">
      <p class="message">how would you like your interface to look like?</p>
      <div class="theme-types-list flex">
        <div
          class="theme flex"
          [class.selected-theme]="selectedThemeIndex === 1"
        >
          <img src="assets/images/system-theme.png" alt="System Theme Image" />
          <p>System</p>
          <mat-checkbox
            color="primary"
            [ngModel]="selectedThemeIndex === 1"
            (change)="changeSelection($event, 1)"
          ></mat-checkbox>
        </div>
        <div
          class="theme flex"
          [class.selected-theme]="selectedThemeIndex === 2"
        >
          <img src="assets/images/dark-theme.png" alt="Dark Theme Image" />
          <p>Dark</p>
          <mat-checkbox
            color="primary"
            [ngModel]="selectedThemeIndex === 2"
            (change)="changeSelection($event, 2)"
          ></mat-checkbox>
        </div>
        <div
          class="theme flex"
          [class.selected-theme]="selectedThemeIndex === 3"
        >
          <img src="assets/images/light-theme.png" alt="Light Theme Image" />
          <p>Light</p>
          <mat-checkbox
            color="primary"
            [ngModel]="selectedThemeIndex === 3"
            (change)="changeSelection($event, 3)"
          ></mat-checkbox>
        </div>
      </div>
      <div class="theme-actions flex w-full">
        <p class="cancel pointer" (click)="closeDialogs()">Cancel</p>
        <button class="button outline-button w-full">
          <span>Save Changes</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
